import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import type { CompanyLogo } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";
import { updateCompanyLogo } from "../api/updateCompanyLogo";

/**
 * Persiste el UUID del logotipo. El archivo se sube antes al servicio de
 * archivos con `useUploadFile`.
 */
export const useUpdateCompanyLogo = (): UseMutationResult<
  ApiResponse<CompanyLogo>,
  ApiError,
  string
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCompanyLogo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: withPrefix(["company"]) });
    },
  });
};
